import { CloudSyncOutlined, SyncOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { ServiceProvider } from 'features/service-providers/models';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { boService } from 'shared/services';

const ButtonSync = ({
  serviceProvider,
  getServiceProvider,
}: {
  serviceProvider: ServiceProvider;
  getServiceProvider: () => Promise<void>;
}) => {
  const [isSyncLoading, setIsSyncLoading] = useState<boolean>(false);

  // Function to handle syncing the service provider with BO
  const syncBOStatus = async (serviceProvider: ServiceProvider) => {
    try {
      setIsSyncLoading(true);
      // Call BO API to sync service provider
      const rs = await boService.createOrUpdateSpFromQBO({ serviceProviderId: serviceProvider.id });
      if (rs) {
        // when call api success we will fetch api get list by this to refetch data for service provider
        setIsSyncLoading(false);
        toast.success('Succès');
        await getServiceProvider();
      }
    } catch (error) {
      // On error, show error toast and reset loading
      console.error(error);
      toast.error((error as Error)?.message);
      setIsSyncLoading(false);
    }
  };
  return (
    <>
      <Button
        type='link'
        className='service-provider-list__sync_bo__button-sync'
        onClick={() => {
          syncBOStatus(serviceProvider);
        }}
      >
        {isSyncLoading ? <SyncOutlined spin /> : <CloudSyncOutlined />}
        Sync BO
      </Button>
    </>
  );
};
export default ButtonSync;
